import { Component, OnInit, Input, Output, EventEmitter, ViewChild, Directive, ViewContainerRef } from '@angular/core';
import { REDEEM, REDEEM_INVESTOR } from '../../../models/redeem';
import { SIMPLE_INVESTOR } from '../../../models/investor';
import { Http, Response, Headers } from '@angular/http';
import { HeaderService } from '../../../header.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as Globals from '../../../globals';
declare var $: any;

@Component({
  selector: 'app-penjatahanissuance-detail',
  templateUrl: './penjatahanissuance-detail.component.html',
  styleUrls: ['./penjatahanissuance-detail.component.css']
})
export class PenjatahanIssuanceDetailComponent implements OnInit {

  param: any;
  @Input() seriesId: number;
  @Input() paramSeries: any;
  investors: SIMPLE_INVESTOR[];
  redeem: REDEEM;
  redeemInvestor: REDEEM_INVESTOR;
  bids: REDEEM_INVESTOR[];
  redeemBids: any[];
  @Input() invId: number;
  @Output() refreshParent = new EventEmitter;
  @Input() userProfile: any;
  loading: boolean;
  p:any;
  errAmt: boolean;
  search: string;
  editRedeem: boolean;
  selectedBidId: number;
  urlFile = Globals.archiveUrl + 'bids?code=';
  showError: boolean;
  @Input() authMenu: any;
  @ViewChild("fileInput") fileInput: any;
  @ViewChild("redeemAmt") redeemAmtEl: any;
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService) {
    this.toastr.setRootViewContainerRef(vRef);
  }
  ngOnInit() {
    this.investors = [];
    this.redeemBids = [];
    //this.newRedeem();
    this.redeem = new REDEEM(0, 0, 0, 0, 0, this.userProfile.USER_ID, null, this.userProfile.GROUP_ID);
    this.paramSeries.MAX_PCENT_ORG = this.paramSeries.MAX_PCENT;
    this.newRedeemInvestor();
    if (this.invId > 0) {
      this.getRedeemInvestor();
    }
  }
  getInvestor() {
    if (this.search.length > 0) {
      this.loading = true;
      this.http.get(Globals.serviceUrl + 'ritel/redeeminvestor?seriesId=' + this.seriesId + '&search=' + this.search + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.investors = res.json();
          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }
  }
  newRedeem() {
    let fi = this.fileInput.nativeElement;
    fi.value = null;
    this.redeem = new REDEEM(0, 0, 0, 0, 0, this.userProfile.USER_ID, null, this.userProfile.GROUP_ID);
    var item: any;
    if (this.bids.length > 0) {
      item = this.bids[0];
      this.redeem.REDEMP_ID = item.BID_ID;
    }
    this.redeem.ALT_AMT = item.ALT_AMT;
  }
  newRedeemInvestor() {
    this.redeemInvestor = new REDEEM_INVESTOR(null, null, null, null, null, null, null, null, null, 0, 0, null, null, false, null, null, null, null, null);
    this.bids = [];
  }
  loadParent() {
    this.refreshParent.emit();
  }
  getRedeemInvestor() {
    this.loading = true;
    this.newRedeemInvestor();
    this.http.get(Globals.serviceUrl + 'ritel/redeeminvestor?invid=' + this.invId + '&seriesId=' + this.seriesId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.bids = res.json();
        if (this.bids.length == 0) {
          this.toastr.warning('Data tidak ditemukan');
        } else {
          this.newRedeem();
          for (var i = 0; i < this.bids.length; i++) {
            this.redeemInvestor.IDTY_NO = this.bids[i].IDTY_NO;
            this.redeemInvestor.INV_NAME = this.bids[i].INV_NAME;
            this.redeemInvestor.SERIES_NAME = this.bids[i].SERIES_NAME;
            this.redeemInvestor.ALT_AMT += this.bids[i].ALT_AMT;
            this.redeemInvestor.REDEEM_AMT += this.bids[i].REDEEM_AMT;
          }
          this.getRedeemBids();
        }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  setRedeem(item: any) {
    let fi = this.fileInput.nativeElement;
    fi.value = null;
    this.redeem.BID_ID = item.BID_ID;
    this.redeem.REDEMP_ID = item.REDEMP_ID;
    this.redeem.ALT_AMT = item.ALT_AMT;
    this.redeem.REDEEM_AMT = item.REDEEM_AMT;
    this.redeem.PCENT = (item.REDEEM_AMT / item.ALT_AMT) * 100;
  }
  changeBidId() {
    var item: any;
    for (var i = 0; i < this.bids.length; i++) {
      if (this.bids[i].BID_ID == this.redeem.REDEMP_ID) {
        item = this.bids[i];
        break;
      }
    }
    this.redeem.ALT_AMT = item.ALT_AMT;
  }
  saveRedeem() {
    this.loading = true;
    let fi = this.fileInput.nativeElement;
    if (this.redeem.BID_ID == 0) {
      this.http.post(Globals.serviceUrl + 'ritel/redeembids', this.redeem, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.uploadFile(res.json().BID_ID, fi);
          $('#redeem').modal('hide');
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    } else {
      this.http.put(Globals.serviceUrl + 'ritel/redeembids?id=' + this.redeem.BID_ID, this.redeem, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.uploadFile(res.json().BID_ID, fi);
          $('#redeem').modal('hide');
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }
  }

  deleteRedeem() {
    this.http.delete(Globals.serviceUrl + 'ritel/bids?id=' + this.redeem.BID_ID, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        $('#modal').modal('hide');
        $('#redeem').modal('hide');
        this.toastr.success('Data berhasil dihapus');
        this.getRedeemInvestor();
        this.loadParent();
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
      });
  }

  uploadFile(id: number, fi: any) {
    if (fi.files && fi.files[0]) {
      let fileToUpload = fi.files[0];
      let input = new FormData();
      input.append("file", fileToUpload);
      let headers = new Headers({ 'Content-Type': 'multipart/form-data' });
      this.http.put(Globals.archiveUrl + "bids?id=" + id, input)
        .subscribe((res: Response) => {
          this.toastr.success(Globals.successMessage());
          this.getRedeemInvestor();
          this.loadParent();
        }, err => {
          console.log(err);
          if (err.status == 400) {
            this.toastr.error('File harus berformat pdf, tif, tiff.');
          }
          else if (err.status == 406) {
            this.toastr.error('File pdf maksimal berukuran 50MB.');
          }
          else {
            //this.toastr.error(Globals.errorMessage(err));
            this.toastr.error('Upload gagal. Silahkan dicoba lagi.');
          }
        });

    } else {
      this.toastr.success(Globals.successMessage());
      this.loadParent();
      this.getRedeemInvestor();
    }
    this.loading = false;
  }

  checkPcent(val: any) {
    if (isNaN(val) || val == '') {
      this.redeem.REDEEM_AMT = 0;
    } else {
      this.redeem.REDEEM_AMT = (val / 100) * this.redeem.ALT_AMT;
    }
  }

  checkRedeemAmt(val: any) {
    if (isNaN(val) || val == '') {
      this.redeem.PCENT = 0;
      this.redeem.REDEEM_AMT = 0;
    } else {
      this.redeem.PCENT = (val / this.redeem.ALT_AMT) * 100;
    }
  }

  generateReport(format: string) {
    this.loading = true;
    this.param = { TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '",format:"' + format + '",invId:"' + this.invId + '"}' };
    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + 'rpt2?id=' + this.param.TICKET_ID, '_blank');
        this.loading = false;
      }, err => {
        this.loading = false;
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }

  onFocus() {
    this.editRedeem = true;
    this.redeemAmtEl.nativeElement.focus();
  }

  getRedeemBids() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/redeembids?invid=' + this.invId + '&seriesId=' + this.seriesId + '&paId=' + this.userProfile.PA_ID + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.redeemBids = [];
        this.redeemBids = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/penjatahan/issuance/penjatahanissuance-detail/penjatahanissuance-detail.component.ts